(function ($, Drupal) {

  Drupal.behaviors.newsletterFormValidation = {
    attach: function (context, settings) {

      $('.hil-newsletter-global-newsletter-form-form', context).once('newsletterFormValidation').each(function () {

        let $nlForm = $(this),
          $input = $nlForm.find('#edit-email');

        $input.on('click', function (e) {
          if ($input.hasClass('input--error')) {
            $input.removeClass('input--error');
          }
        });

        function initErrors() {

          let $message = $nlForm.find('.messages--error').text().slice(0, -1),
              $success = $('.messages--success');

          $input.addClass('input--error');
          $nlForm.find('#edit-email').val('').attr('placeholder', $message);

          $success.find('.close').on('click', function() {
            $success.remove();
          });
        }

        $(document).ajaxComplete(function (event, xhr, settings) {
          if (settings.url.indexOf("drupal_ajax") > -1) {
            initErrors();
          }
        });

      });

    }
  };

})(jQuery, Drupal);
